import { render } from "./TestReviewTab.vue?vue&type=template&id=61a58322&scoped=true"
import script from "./TestReviewTab.vue?vue&type=script&lang=js"
export * from "./TestReviewTab.vue?vue&type=script&lang=js"

import "./TestReviewTab.vue?vue&type=style&index=0&id=61a58322&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a58322"]])

export default __exports__